import React, { Component } from "react";
import { Button } from "react-bootstrap";
import _ from "lodash";
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import "./DeleteConfirmForm.scss";

class DeleteConfirmForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      contentType: '',
      sort: 1,
      description: ''
    }
  }

  render() {
    return (
      <div className="delete-confirm-form">
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <div className="user-container d-flex flex-column align-items-center p-4">
          {this.props.type === 'user' && 
            <div>
              <div><strong>Are you sure you want to delete this user?</strong></div>
              <div>You can't undo deleting a user, but you can re-invite them.</div>
            </div>
          }
          {this.props.type === 'item' && 
            <div>
              <div className="delete-title">Delete item?</div>
              <div className="delete-question">Are you sure you want to delete "{`${_.get(this.props.data, 'meta.contentTitle', '')} ${_.get(this.props.data, 'meta.contentType', '')}`}"?</div>
            </div>
          }
          {
            this.props.type === 'settingsItem' &&
            <div>
            <div className="delete-title">Delete Account Settings</div>
              <div className="delete-question">
                Are you sure you want to remove "{this.props.settingsKey}"? <br/>
                Removing this option won’t remove this for existing items
              </div>
            </div>
          }
          {this.props.type === 'wish' && 
            <div>
              <div className="delete-title">Delete wish?</div>
              <div className="delete-question">Are you sure you want to delete "{`${_.get(this.props.data, 'contentType', '')} ${_.get(this.props.data, 'title', '')}`}"?</div>
            </div>
          }
          {this.props.type === 'importHistory' && 
            <div>
              <div className="delete-title">Delete import?</div>
              <div className="delete-question">Are you sure you want to delete items imported from "{this.props.filename}"?</div>
            </div>
          }
          {this.props.type === 'collection' && 
            <div>
              <div className="delete-title">Delete collection?</div>
              <div className="delete-question">Are you sure you want to delete collection "{this.props.collection.title}"?</div>
            </div>
          }
          {
            this.props.type === 'updateTracer' &&
            <div>
              <div className="delete-title">Update Tracker</div>
              <div className="delete-question">Are you sure you want to update {this.props.data} tracker?</div>
            </div>
          }
          <div className="actions-box mt-4">
            <Button variant="outline-danger" className="mr-2" size="sm" onClick={this.props.onClose}>CANCEL</Button>
            <Button
              variant="outline-danger"
              className="mr-2"
              size="sm"
              onClick={this.props.onConfirm}
            >
              {this.props.type === 'updateTracer' ? 'UPDATE' : 'DELETE'}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default DeleteConfirmForm;
